module.exports = __webpack_public_path__ + "catalog/items/dining/dining-table-for-4/dining-table-for-4.svg";